import { render, staticRenderFns } from "./SaleServiceOrderViewItem.vue?vue&type=template&id=f055a6d6&scoped=true&"
import script from "./SaleServiceOrderViewItem.vue?vue&type=script&lang=js&"
export * from "./SaleServiceOrderViewItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleServiceOrderViewItem.vue?vue&type=style&index=0&id=f055a6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f055a6d6",
  null
  
)

export default component.exports